export const getProjectColorByName = (project) => {
  switch (project) {
    case 'Foundation':
      return { color: '#e53935', bgColor: '#fdecea' }; // red
    case 'Classroom':
      return { color: '#1e88e5', bgColor: '#e8f5e9' }; // green
    case 'LG':
      return { color: '#43a047', bgColor: '#e3f2fd' }; // blue
    case 'STC':
      return { color: '#9f44b6', bgColor: '#fff3e0' }; // orange
    default:
      return { color: '#6b7280', bgColor: '#f3f4f6' }; // gray
  }
};

export const getCardsColorByName = (title) => {
  switch (title) {
    case 'Total Revenue':
      return { color: '#e3f2fd', border: '#b3d2e9' };
    case 'Total Sales':
      return { color: '#f3e5f5', border: '#eccaf1' };
    case 'TAR':
      return { color: '#ffebee', border: '#f8c3cb' };
    case 'ACR':
      return { color: '#e0f7fa', border: '#bdedf3' };
    case 'SFR':
      return { color: '#ede7f6', border: '#d4bef5' };
    case 'LCR':
      return { color: '#e8f5e9', border: '#bfeec3' };
    default:
      return { color: '#6b7280', border: '#f3f4f6' }; // gray
  }
};

export const getMilestoneAchiever = (rank) => {
  switch (rank) {
    case 1:
      return { color: '#ed8e00' };
    case 2:
      return { color: '#6b7280' };
    case 3:
      return { color: '#e91e63' };
    default:
      return { color: '#9c27b0' };
  }
};

export const getOGDPerfomers = (title) => {
  switch (title) {
    case 'Sales Titans':
      return { bg: 'linear-gradient(135deg, #ff416c, #ff4b2b)' };
    case 'Goal Crashers':
      return { bg: 'linear-gradient(135deg, #11998e, #38ef7d)' };
    case 'Big Deal Maestros':
      return { bg: 'linear-gradient(135deg, #1e3c72, #2a5298)' };
    case 'Admission Gurus':
      return { bg: 'linear-gradient(135deg, #8e2de2, #4a00e0)' };
    default:
      return { bg: 'linear-gradient(135deg, #8e2de2, #4a00e0)' };
  }
};
